export default __webpack_public_path__ + "static/media/40a8975aff9c933441ac77826a638af3.eb79f2d2.png";